import request from "@/utils/request";

// 获取通知相关的文件列表
export function getStartPlay(params) {
  return request({
    url: '/cloud/monitor/vehicle/videoPlay',
    method: "get",
    params: params
  });
}